import { useRef } from "react"
import { TickerAnimation } from "./componets/tickerAnimation"


export const HeroSection=()=>{

    const heroLogoRef=useRef(null)

    console.log(heroLogoRef.current?.style)


    return(
        <div className="hero-section">
            <div className="__container">
                <div className="hero-section_row">
                    <div className="hero-section_row-el">
                        <div  ref={heroLogoRef} className="hero-ujjo">
                            <img src={require("../../../../static/Framehero_ujjo.png")}/>
                        </div>
                        <TickerAnimation/>
                        <div className="hero-1">
                            <img src={require('../../../../static/IMAGE-hero1.jpg')}/>
                        </div>
                    </div>
                    <div className="hero-section_row-el">
                        <div className="hero-section_title">
                            <p>THE FIRST HOT SAUCE MADE FOR COFFEE</p>
                        </div>
                        <div className="hero-2">
                            <img src={require('../../../../static/IMAGE-hero-2.jpg')}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}